import React from "react";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import AddChips from "../reusable-components/addChips";
import { withStyles } from "@material-ui/core/styles";
import { debounce } from "lodash";
import fire from "../../config/firebase";
import { withRouter } from "react-router-dom";
import { compose } from "@reduxjs/toolkit";
const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
});
class ChipsArray extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chipData: [],
      chipname: "",
      deleteKey: "",
      arrayAction: "",
      tagsList: [],
    };
    this.chiptags = [...this.state.chipData];
    this.getTable = this.getTable.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.getKey = this.getKey.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }
  handleDelete(chipToDelete) {
    const { tagsList } = this.state;
    const newTaglist = tagsList.filter((d) => d.title !== chipToDelete);
    if (this.getKey()) {
      const userRef = fire.database().ref(this.getTable()).child(this.getKey());
      userRef.update({
        tags: newTaglist,
      });

      this.refreshData();
    }
  }
  handleComboBox = debounce((newValue) => {
    let chipname = "";
    if (newValue) {
      chipname = newValue;
      this.setState({
        chipname: newValue["title"],
        arrayAction: "new",
      });

      if (typeof newValue.title === "object") {
        this.setState({ chipname: newValue.inputValue });
        chipname = newValue.inputValue;
      }
      const { tagsList } = this.state;
      if (chipname) {
        tagsList.push({
          title: chipname.title ? chipname.title : chipname,
        });
        const userRef = fire
          .database()
          .ref(this.getTable())
          .child(this.getKey());
        userRef.update({
          tags: tagsList,
        });
        this.refreshData();
      }
    }
  }, 300);
  getTable() {
    const { dataType, isTemplate } = this.props;
    if (dataType) {
      return dataType;
    }
    if (isTemplate) {
      return "templates";
    }
    return "estimates";
  }
  getKey() {
    const arr = this.props.location.pathname.split('/');
    const key = arr[arr.length - 1];
    return this.props.itemId || key;
  }
  refreshData() {
    const key = this.getKey();
    if (key) {
      const userRef = fire.database().ref(this.getTable()).child(key);
      userRef.once("value").then((snapshot) => {
        const tags = snapshot.val();
        userRef.off("value");
        this.setState({ tagsList: tags ? tags.tags || [] : [] });
      });
    }
  }
  componentDidMount() {
    this.refreshData();
  }
  render() {
    const { classes, allTags = [] } = this.props;
    const { tagsList = [] } = this.state;
    const tempAllTags = allTags.filter(d => { return tagsList.find(t => (t.title || '').toLowerCase() === (d.title || '').toLowerCase()) === undefined });
    const curKey = this.getKey();
    //triming Tag included here as well.
    function capitalizeFirstLetter(str = "") {
      return str && str.length > 0 ? str.charAt(0).toUpperCase() + (str.length <= 15 ? str.slice(1, 15) : str.slice(1, 15) + '...') : str;
    }
    return (
      <Paper component="ul" className={classes.root}>
        {tagsList.map(({ title = "" }, index) => {
          return (
            <li
              key={curKey + index}
            //Tags Error
            //className={title.length > 30 ? "errorState" : null}
            >
              <Chip
                label={capitalizeFirstLetter(title)}
                onDelete={() => this.handleDelete(title)}
                className={classes.chip}
              />
            </li>
          );
        })}
        {tagsList.length < 3 ? (
          <AddChips
            key={this.getKey() + "addchips" + tempAllTags.length}
            classes={this.props.classes.addTask}
            resourceItem={this.props.resourceItem}
            title={"+ Tag"}
            show={this.itemShow}
            selectedValue={this.handleComboBox}
            allTags={tempAllTags}
            refreshData={this.props.refreshData}
          />
        ) : (
          ""
        )}
      </Paper>
    );
  }
}

const withstyle = withStyles(styles)(ChipsArray);

export default compose(withRouter)(withstyle);
